// Vendor imports
const { connect } = require('react-redux')
const { createSelector } = require('reselect')
// Client V2 common imports
const ImmutableToJS = require('client-v2/common/components/immutable-to-js')
const { mapDispatchToProps } = require('client-v2/common/containers/auth-modal/actions-component')
// Entry imports
const TopCallToActionSplitTrailing = require('./split-trailing-dumb')

function mapStateToProps(state) {
  return {
    article: state.topCallToAction.article,
    collection: state.topCallToAction.collection,
    placeholderImage: state.env.articlePlaceholder,
    showPromos: showPromosSelector(state)
  }
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  ImmutableToJS(
    TopCallToActionSplitTrailing
  )
)

const showPromosSelector = createSelector(
  [
    state => state.env.browser,
    state => state.env.nativeEmbedded
  ],
  (browser, nativeEmbedded) => {
    return Boolean(
      !browser.get('native') &&
      !nativeEmbedded &&
      !browser.get('android') &&
      !browser.get('ios')
    )
  }
)
